import { c as _c } from "react/compiler-runtime";
import { Button } from "@opensea/next-ui-kit";
import { classNames, FlexCenter, Separator } from "@opensea/ui-kit";
import { Delete, Edit, KeyboardArrowDown, KeyboardArrowUp, Publish } from "@opensea/ui-kit/icons";
import { useShallow } from "zustand/react/shallow";
import { useOverviewPreviewStore } from "@/components/collection/overview/components/OverviewPreviewProvider/OverviewPreviewProvider";
import { getModuleType, openEditSidebar } from "@/components/studio/page-editor/utils";
export function PreviewActionBar(t0) {
  const $ = _c(44);
  const {
    className,
    moduleIndex
  } = t0;
  const [modules, moduleCount, moveModule, deleteModule] = useOverviewPreviewStore(useShallow(_temp));
  let t1;
  if ($[0] !== moduleIndex || $[1] !== moveModule) {
    t1 = () => {
      if (moduleIndex > 0) {
        moveModule(moduleIndex, moduleIndex - 1);
      }
    };
    $[0] = moduleIndex;
    $[1] = moveModule;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleMoveUp = t1;
  let t2;
  if ($[3] !== moduleCount || $[4] !== moduleIndex || $[5] !== moveModule) {
    t2 = () => {
      if (moduleIndex < moduleCount - 1) {
        moveModule(moduleIndex, moduleIndex + 1);
      }
    };
    $[3] = moduleCount;
    $[4] = moduleIndex;
    $[5] = moveModule;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleMoveDown = t2;
  let t3;
  if ($[7] !== moduleIndex || $[8] !== moveModule) {
    t3 = () => {
      if (moduleIndex > 0) {
        moveModule(moduleIndex, 0);
      }
    };
    $[7] = moduleIndex;
    $[8] = moveModule;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const handleMoveToFirst = t3;
  let t4;
  if ($[10] !== deleteModule || $[11] !== moduleIndex) {
    t4 = () => {
      deleteModule(moduleIndex);
    };
    $[10] = deleteModule;
    $[11] = moduleIndex;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const handleDelete = t4;
  let t5;
  if ($[13] !== moduleIndex || $[14] !== modules) {
    t5 = () => {
      const moduleData = modules?.[moduleIndex];
      if (!moduleData) {
        return;
      }
      const moduleType = getModuleType(moduleData);
      if (!moduleType) {
        return;
      }
      openEditSidebar(moduleIndex, moduleType);
    };
    $[13] = moduleIndex;
    $[14] = modules;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const handleEdit = t5;
  const isFirst = moduleIndex === 0;
  const isLast = moduleIndex === moduleCount - 1;
  let t6;
  if ($[16] !== className) {
    t6 = classNames("gap-3", className);
    $[16] = className;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <KeyboardArrowUp size={20} />;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== handleMoveUp || $[20] !== isFirst) {
    t8 = <Button disabled={isFirst} icon={t7} onClick={handleMoveUp} size="sm" variant="secondary" />;
    $[19] = handleMoveUp;
    $[20] = isFirst;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <KeyboardArrowDown size={20} />;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== handleMoveDown || $[24] !== isLast) {
    t10 = <Button disabled={isLast} icon={t9} onClick={handleMoveDown} size="sm" variant="secondary" />;
    $[23] = handleMoveDown;
    $[24] = isLast;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Publish size={20} />;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== handleMoveToFirst || $[28] !== isFirst) {
    t12 = <Button disabled={isFirst} icon={t11} onClick={handleMoveToFirst} size="sm" variant="secondary" />;
    $[27] = handleMoveToFirst;
    $[28] = isFirst;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Separator orientation="vertical" />;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Edit size={20} />;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== handleEdit) {
    t15 = <Button icon={t14} onClick={handleEdit} size="sm" variant="secondary" />;
    $[32] = handleEdit;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Delete size={20} />;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== handleDelete) {
    t17 = <Button icon={t16} onClick={handleDelete} size="sm" variant="secondary" />;
    $[35] = handleDelete;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t10 || $[38] !== t12 || $[39] !== t15 || $[40] !== t17 || $[41] !== t6 || $[42] !== t8) {
    t18 = <FlexCenter className={t6}>{t8}{t10}{t12}{t13}{t15}{t17}</FlexCenter>;
    $[37] = t10;
    $[38] = t12;
    $[39] = t15;
    $[40] = t17;
    $[41] = t6;
    $[42] = t8;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  return t18;
}
function _temp(state) {
  return [state.modules, state.modules?.length ?? 0, state.moveModule, state.deleteModule];
}